import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async get () {
    return Api().get('/v1/vendors')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Vendor.Messages.GetVendorsErrorMessage'),
          color: 'error',
        })
        console.error(error)
       return { success: false }
      })
  },
}
